/**
 * Classe usada para montar o elemento PicklistMultiselect.
 * Eh aquele que o usuario pode escolher varias opcoes em uma lista
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PickListMultiselect = (function () {

    function PickListMultiselect () {

        Monet.UI.Fields.PickList.apply (this, arguments);

        this.createBaseStructure ();

        this.defaultValue = null;
        this.input = null;
        this.value = [];

        var getValueByFieldDomain = function (valueOptions){

            var value = '';

            if(valueOptions){
                for(var i = 0, length = valueOptions.length; i < length;  i++) {

                    if(valueOptions[i].trim()){

                        value += valueOptions[i] + ",";
                    }
                }

                value = value.substring(0, value.length - 1);
            }

            return value;
        };

        var getValueByEntity = function (scope) {

            return function (valueOptions) {
                var value = [];

                if(valueOptions){
                    for(var i = 0, length = valueOptions.length; i < length;  i++) {
                        var id =  valueOptions[i].trim();
                        if(id){
                            value.push( scope.formatFieldToJson(id));
                        }
                    }
                }

                return value;
            };
        } (this);


        this.getValue = function () {

            this.value = [];

            if(this.input){
                var valueOptions = $(this.input).val();
                if ( this.dataIsFieldDomain()) {
                   this.value = getValueByFieldDomain(valueOptions);
                } else {
                    this.value = getValueByEntity(valueOptions);
                }
            }

            return this.value;

        };

        this.isEmpty = function () {
            var value = this.getValue();

            if ( this.dataIsFieldDomain()) {
                //Gambiarra foda, mas foi o unico modo que consegui para fazer o metodo isEmpty funcionar
                if(value === '' || value === 'Monet.UI.Fields.PickList.Loading'){
                    return true;
                }
            } else {
                if(value.length === 0){
                    return true;
                }
            }

            return false;
        };

        var setValuesOnSelect = function (options, values){

            for(var i = 0, length = options.length; i < length;  i++) {
                var option = options[i];
                if(option.value && values.indexOf(option.value) !== -1){
                    option.selected = true;
                }
            }
        };

        var setValueFromDatabase = function(scope) {

            return function (options, values) {
                var size = values.length;
                var idsSelected = [];
                for (var i = 0; i < size; i++) {
                    var value = scope.getValueFromJsonElement(values[i]);
                    if (value) {

                        idsSelected.push( value.id ? value.id.toString() : value);
                    }
                }
                setValuesOnSelect(options, idsSelected);
            };
        }(this);

        this.setValue = function (value) {

            if(value ) {
                this.value = value || '';
                var options = this.input.options;

                if (value && this.dataIsFieldDomain()) {
                    setValuesOnSelect(options, value.split(','));
                } else {
                    if(typeof value === "string"){
                        value = JSON.parse(value);
                    }
                    setValueFromDatabase(options, value);
                }
            }
        };


        this.clear = function () {

            var valueOptions = this.input.selectedOptions;
            for(var i = 0, length = valueOptions.length; i < length;  i++) {
                valueOptions[i].selected = false;
            }
            this.value = [];

        };

        this.render = function () {
            this.createElement ();
            this.checkPickListTypeAndRequestData (this.successOfRequestData);

            this.input.multiple = true;

            return this.rootEl;

        };

    }

    return PickListMultiselect;

}());